// 12 seconds
export const AVERAGE_L1_BLOCK_TIME = 12000
